import { isEmptyObject, parseJsonStringSafely } from '@teko/utils';
import TerraKit from '@terra-js/terra-kit';
import { IHamperData } from 'types';
import {
  CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY,
  CUSTOM_HAMPER_LOCAL_STORAGE_KEY,
} from '../constants/hamper';
export const MAXIMUM_COUNT_HAMPER = 5;

export const getHamperDataLocalConfigs = (): IHamperData => {
  let result: IHamperData = {
    configs: [
      { quantity: 0 },
      { quantity: 0 },
      { quantity: 0 },
      { quantity: 0 },
      { quantity: 0 },
    ],
    activeIndex: 0,
    hampers: [],
  };
  const hamperKey = TerraKit.isAvailable()
    ? CUSTOM_HAMPER_LOCAL_STORAGE_APP_KEY
    : CUSTOM_HAMPER_LOCAL_STORAGE_KEY;
  const hamperLocalConfigs: string | null =
    typeof window !== 'undefined' ? localStorage.getItem(hamperKey) : null;
  if (
    !!hamperLocalConfigs &&
    !isEmptyObject(parseJsonStringSafely(hamperLocalConfigs) as IHamperData)
  ) {
    const hamperConfig = parseJsonStringSafely(
      hamperLocalConfigs,
    ) as IHamperData;
    if (!!hamperConfig.configs) {
      const countLackHamper =
        MAXIMUM_COUNT_HAMPER - hamperConfig.configs.length;
      for (let i = 0; i < countLackHamper; i++) {
        hamperConfig.configs.push({ quantity: 0 });
      }
    }
    result = {
      configs: hamperConfig.configs || [
        { quantity: 0 },
        { quantity: 0 },
        { quantity: 0 },
        { quantity: 0 },
        { quantity: 0 },
      ],
      activeIndex: hamperConfig.activeIndex || 0,
      hampers: hamperConfig.hampers || [],
      cartToken: hamperConfig.cartToken,
    };
  }
  return result;
};

export const buildHamperNote = (
  hamper: IHamperData,
  flattenItems: Array<{ name: string; sku: string; quantity: number }>,
) => {
  const flattenItemsBySku = new Map(
    flattenItems.map((item) => [item.sku, item]),
  );

  const hamperNoteParts: string[] = [];

  hamper.configs.forEach((cfg, index) => {
    if (cfg.quantity !== 0) {
      const lines: string[] = [];
      lines.push(`Giỏ tự build ${index + 1} (SL: ${cfg.quantity}):`);

      Object.values(cfg).forEach((value) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            const name = flattenItemsBySku.get(item.sku)?.name;
            if (name) {
              lines.push(`- ${item.quantity}x ${name}`);
            }
          });
        }
      });

      hamperNoteParts.push(lines.join('\n'));
    }
  });

  return hamperNoteParts.join('\n\n');
};
